// SnackbarComponent.jsx
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const SnackbarComponent = ({ open, onClose, severity, message }) => {
    return (
        <Snackbar open={open} autoHideDuration={3000} onClose={onClose}>
            <MuiAlert elevation={6} variant="filled" onClose={onClose} severity={severity}>
                {message}
            </MuiAlert>
        </Snackbar>
    );
};

export default SnackbarComponent;
